import { createRoute } from '@tanstack/react-router'

import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { JSON } from 'domains/Showcases/Collections/AccessKeys/AccessKey'
import { Structure } from 'pages/NWPlatform/Collections/Collection/AccessKey/Structure'
import { collectionRoute } from 'pages/NWPlatform/Collections/Collection/Routing'

export const accessKeyRoute = createRoute({
  getParentRoute: () => collectionRoute,
  path: `${StaticRouteParameter.ACCESS_KEYS}/${DynamicRouteParameterWPrefix.ACCESS_KEY_ID}`,
  loader: () => ({
    crumb: { title: null },
  }),
})

export const accessKeyLayoutRoute = createRoute({
  getParentRoute: () => accessKeyRoute,
  id: 'showcaseCollectionAccessKeyLayout',
  component: Structure,
})

export const configRoute = createRoute({
  getParentRoute: () => accessKeyLayoutRoute,
  path: StaticRouteParameter.CONFIG,
  component: JSON,
})
